import React from 'react';
import PropTypes from 'prop-types';
import classes from './Recovery.scss';

import { AutoSizer, Column, Table } from 'react-virtualized';
import { List } from 'immutable';
import localizedType from '../../../helpers/localizedType';
import { filterIt } from '../../../helpers/filterIt';

const SortDirection = {
  /**
   * Sort items in ascending order.
   * This means arranging from the lowest value to the highest (e.g. a-z, 0-9).
   */
  ASC: 'ASC',

  /**
   * Sort items in descending order.
   * This means arranging from the highest value to the lowest (e.g. z-a, 9-0).
   */
  DESC: 'DESC',
};

class Recovery extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      filter: '',
      sortBy: null,
      sortDirection: SortDirection.ASC,
      sortedList: [],
    };
  }

  componentDidMount() {}

  /*
  sort = ({ sortBy, sortDirection }) => {
    const sortedList = this.sortList({ sortBy, sortDirection });

    this.setState({ sortBy, sortDirection, sortedList });
  };

  sortList = ({ sortBy, sortDirection }) => {
    const { list } = this.context;

    return list
      .sortBy(item => item[sortBy])
      .update(
        list => (sortDirection === SortDirection.DESC ? list.reverse() : list),
      );
  };
*/
  renderButtonCell = cellData => {
    return (
      <button
        className={`button button-primary`}
        onClick={() => {
          if (confirm(`"${cellData.title}" wirklich wiederherstellen?`)) {
            this.props.restoreObject(
              encodeURIComponent(cellData.type),
              cellData.id,
            );
          }
        }}
      >
        Wiederherstellen
      </button>
    );
  };

  render() {
    let list = [];

    this.props.activities.forEach(activity => {
      list.push({
        type: 'App\\Activity',
        typeForHumans: localizedType('App\\Activity'),
        title: activity.title,
        id: activity.id,
        deleted_at: activity.deleted_at,
      });
    });

    this.props.companies.forEach(company => {
      list.push({
        type: 'App\\Company',
        typeForHumans: localizedType('App\\Company'),
        title: company.name,
        id: company.id,
        deleted_at: company.deleted_at,
      });
    });

    this.props.tasks.forEach(task => {
      list.push({
        type: 'App\\Task',
        typeForHumans: localizedType('App\\Task'),
        title: task.title,
        id: task.id,
        deleted_at: task.deleted_at,
      });
    });

    this.props.projects.forEach(project => {
      list.push({
        type: 'App\\Project',
        typeForHumans: localizedType('App\\Project'),
        title: project.name,
        id: project.id,
        deleted_at: project.deleted_at,
      });
    });

    this.props.staffs.forEach(staff => {
      list.push({
        type: 'App\\Staff',
        typeForHumans: localizedType('App\\Staff'),
        title: staff.name,
        id: staff.id,
        deleted_at: staff.deleted_at,
      });
    });

    this.props.persons.forEach(person => {
      list.push({
        type: 'App\\Person',
        typeForHumans: localizedType('App\\Person'),
        title: person.name,
        id: person.id,
        deleted_at: person.deleted_at,
      });
    });

    let filteredList = null;

    if (this.state.filter.length) {
      filteredList = filterIt(
        list,
        this.state.filter,
        ['title', 'deleted_at', 'typeForHumans'],
        [],
      );
    } else {
      filteredList = list;
    }

    return (
      <div className="wrapper recovery-index">
        <div>
          <div className={classes.top}>
            <div className={classes.title}>
              <h2 className={`${classes.zenHeader} gutter`}>Datenrettung</h2>
              <p className={`gutter`}>
                Sollten aus versehen jegliche Daten gelöscht worden sein, können
                Sie diese hier wiederherstellen.
              </p>
            </div>

            <div className={classes.searchBar}>
              <input
                className={classes.search}
                type="search"
                placeholder="Suche…"
                onChange={e => {
                  this.setState({
                    filter: e.target.value,
                  });
                }}
              />
            </div>
          </div>

          <AutoSizer disableHeight>
            {({ height, width }) => (
              <Table
                headerHeight={30}
                height={window.innerHeight - 250}
                rowCount={filteredList.length}
                rowGetter={({ index }) => filteredList[index]}
                rowHeight={40}
                width={width}
                // sort={this.sort}
                // sortBy={this.state.sortBy}
                // sortDirection={this.state.sortDirection}
              >
                <Column label="Bezeichnung" dataKey="title" width={640} />
                <Column width={200} label="Typ" dataKey="typeForHumans" />
                <Column width={200} label="Gelöscht am" dataKey="deleted_at" />
                <Column
                  label="Aktion"
                  width={170}
                  dataKey="id"
                  cellRenderer={({ rowData }) => this.renderButtonCell(rowData)}
                />
              </Table>
            )}
          </AutoSizer>
        </div>
      </div>
    );
  }
}

Recovery.propTypes = {
  activities: PropTypes.array,
  companies: PropTypes.array,
  staffs: PropTypes.array,
  persons: PropTypes.array,
  tasks: PropTypes.array,
  projects: PropTypes.array,
  restoreObject: PropTypes.func,
};

Recovery.defaultProps = {
  activities: [],
  companies: [],
  staffs: [],
  persons: [],
  tasks: [],
  projects: [],
};

export default Recovery;



// WEBPACK FOOTER //
// ./src/routes/Recovery/components/Recovery.js